/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of user
 */
export enum ArchiveUserStatusDTO {
    ENABLED = 'enabled',
    DISABLED = 'disabled'
}

export class ClsArchiveUserStatusDTO {
    ENABLED = 'enabled';
    DISABLED = 'disabled';
}

